import React from 'react';
import { SystemSpaceForm, mountForm, unmountForm } from '@kineticdata/react';
import { generateFormButtons, FormError, TableField } from '@kineticdata/ui';
import { regRoute, regSaga } from '../../store';
import { navigate } from '../../root';
import { call, takeEvery } from 'redux-saga/effects';

const spaceFormKey = spaceSlug => `tenant-edit-space-form-${spaceSlug}`;

regRoute('TENANT_EDIT_SPACE_PAGE', '/spaces/edit/:spaceSlug/general');
regSaga(
  takeEvery('ENTER_TENANT_EDIT_SPACE_PAGE', function*({ payload }) {
    const { spaceSlug } = payload.params;
    yield call(mountForm, spaceFormKey(spaceSlug));
  }),
);

regSaga(
  takeEvery('LEAVE_TENANT_EDIT_SPACE_PAGE', function*({ payload }) {
    const { spaceSlug } = payload.params;
    yield call(unmountForm, spaceFormKey(spaceSlug));
  }),
);

const handleSave = () => ({ slug }) => {
  if (slug) {
    // If we got a `space` back with a slug then it was an edit and we go back to the list.
    navigate(`/spaces`);
  }
};

const FormLayout = ({ fields, error, buttons }) => (
  <form>
    <div className="row">
      <div className="col-6">{fields.get('name')}</div>
      <div className="col-6">{fields.get('slug')}</div>
    </div>
    {fields.get('sharedBundle')}
    {fields.get('sharedBundleBase')}
    {fields.get('bundlePath')}
    {fields.get('allowedIpsEnabled')}
    {fields.get('allowedIps')}
    {error}
    <div className="form-buttons">{buttons}</div>
  </form>
);

export const SpaceEditForm = ({ slug, onDelete }) => (
  <SystemSpaceForm
    formKey={spaceFormKey(slug)}
    slug={slug}
    fieldSet={[
      'name',
      'slug',
      'sharedBundle',
      'sharedBundleBase',
      'bundlePath',
      'allowedIpsEnabled',
      'allowedIps',
    ]}
    components={{
      FormError,
      FormButtons: generateFormButtons({
        handleDelete: onDelete,
        submitLabel: slug ? 'Update Space' : 'Create Space',
        cancelPath: '/spaces',
      }),
      FormLayout,
    }}
    alterFields={{
      allowedIps: { component: TableField },
    }}
    onSave={handleSave}
  >
    {({ form, initialized }) =>
      initialized && <div className="content-container">{form}</div>
    }
  </SystemSpaceForm>
);
